/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/self-closing-comp */
/* eslint-disable prettier/prettier */
/* eslint-disable simple-import-sort/imports */
/* eslint-disable react/function-component-definition */
/* eslint-disable no-console */
import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { message } from 'antd';
import { api, ApiResponse } from '../../services/api';
import SocialLogin from '../../components/SocialLogin/SocialLogin';

interface RegisterConfirmProps {
  className?: string;
}

const RegisterConfirm: React.FC<RegisterConfirmProps> = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Get registration type from URL parameters
  const urlRegistrationType = searchParams.get('registrationType');

  // Get clubId from URL parameters or use a random number as specified
  const clubId = 100;

  useEffect(() => {
    document.title = 'ClubPro - Confirm Registration';
  }, []);

  const handleSocialLoginSuccess = async () => {
    setIsSubmitting(true);

    try {
      // Get social login data from localStorage
      const socialToken = localStorage.getItem('SocialLoginToken') || '';
      const provider = localStorage.getItem('LoginProvider') || 'GOOGLE';

      // Get encryptedUuid from URL parameters
      const encryptedUuid =  searchParams.get('uuid');

      // Prepare payload according to user's specification
      const payload = {
        encryptedUuid,
        socialToken,
        provider,
        clubId
      };


      // Determine API endpoint based on URL registrationType parameter
      let endpoint:any; // default fallback

      if (urlRegistrationType === 'ON_BOARD_PLAYER') {
        endpoint = '/club/onboard-register-player';
      } else if (urlRegistrationType === 'ON_BOARD_GUARDIAN') {
        endpoint = '/club/onboard-register-guardian';
      }

      // Make API call using the api service
      const response: ApiResponse = await api.post(endpoint, payload);

      if (response.error) {
        throw new Error(response.error);
      }


      // Show success message
      message.success('Registration completed successfully!');

      // Redirect to success page or dashboard
      navigate('/login');

    } catch (error: any) {
      console.error('Registration failed:', error);
      const errorMessage = error?.response?.data?.message || error?.message || 'Registration failed. Please try again.';
      message.error(errorMessage);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className='w-full' >
      <div className="min-h-screen w-full bg-gray-50 flex items-center justify-center px-4">
        <div className="max-w-md w-full bg-white rounded-xl shadow-lg p-8">
          {/* Header */}
          <div className="text-center mb-8">
            <div className="w-16 h-16 bg-gradient-to-r from-indigo-500 to-purple-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <span className="text-white font-bold text-xl">C</span>
            </div>
            <h1 className="text-2xl font-bold text-gray-900 mb-2">
              Complete Your Registration
            </h1>
            <p className="text-gray-600">
              Sign in with your preferred social account to complete the registration process.
            </p>
          </div>

          {/* Social Login Component */}
          <div className="mb-6">
            <SocialLogin
              onSuccess={handleSocialLoginSuccess}
              buttonText="Continue with Google"
              showOnlyGoogle
            />
          </div>


          {/* Loading State */}
          {isSubmitting && (
            <div className="text-center mt-4">
              <div className="inline-block animate-spin rounded-full h-6 w-6 border-b-2 border-indigo-600"></div>
              <p className="mt-2 text-sm text-gray-600">Processing registration...</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default RegisterConfirm;
